import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dialog } from '@mui/material';
import { closeAuthDialog } from '../../app/store/slices/authDialog';
import { authModules } from '../../app/store/slices/authDialog';
import LoginModuleManage from './login/LoginModuleManage';
import RegisterModuleManage from './register/RegisterModuleManage';
import GuestLogin from './guest-login/GuestLogin';

function AuthModule() {
    const dispatch = useDispatch();
    const selector = useSelector((state) => state.authDialog);

    return (
        <React.Fragment>
            <Dialog
                // variant="login"
                open={selector.isAuthDialogOpen}
                onClose={() => dispatch(closeAuthDialog())}
                sx={dialogStyles}
            >
                {selector.activeAuthModule === authModules.LOGIN && <LoginModuleManage />}
                {selector.activeAuthModule === authModules.REGISTER && <RegisterModuleManage />}
                {selector.activeAuthModule === authModules.GUEST && <GuestLogin />}
            </Dialog>
        </React.Fragment>
    );
}

export default AuthModule;

const dialogStyles = {
    '& .MuiPaper-root': {
        width: '475px',
        // height: '555px',
        padding: '2rem',
        display: 'flex',
        border: 'none',
        borderRadius: '1rem',
        background: 'var(--gradient-blue)',
        scrollbarWidth: 'none'
    }
};
